import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";
import { ZSpecification } from "src/business/specification";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { MdmTable } from "src/components/MdmTable";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ManagementSpecCommonListStore } from "./ManagementSpecCommonListStore";
import { ManagSpecActions } from "./ManagSpecActions";

type PropsManagementSpecCommonList = {
  cardUrl: PageUrl;
  pageStore: ManagementSpecCommonListStore;
};

export const ManagementSpecCommonList: React.FC<
  PropsManagementSpecCommonList
> = (props) => {
  const { cardUrl, pageStore } = props;
  const { tableStore } = pageStore;

  const tools = (
    <>
      <ManagSpecActions pageStore={pageStore} />
      <RtColumnsSettingsButton store={tableStore} />
      <Link to={makeUrl(cardUrl, { id: "new" })}>
        <Button type="primary" icon={<PlusCircleOutlined />}>
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <ToolBox2 extraTools={tools} paddingMode="page">
      <MdmTable
        store={tableStore}
        columns={columns}
        rowClick={{
          type: "link",
          builder: (row) => makeUrl(cardUrl, { id: row.id }),
        }}
      />
    </ToolBox2>
  );
};

const columns: RtColumn<ZSpecification>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    render: (row) => row.name,
  },
  {
    key: "displayName",
    title: "Название",
    render: (row) => row.displayName,
  },
  {
    key: "description",
    title: "Описание",
    render: (row) => row.description,
  },
  {
    key: "attrsCount",
    title: "Количество атрибутов",
    render: (row) => row.definition?.attributes.length ?? 0,
    align: "center",
  },
  ...sysColumnsHistory,
];
